import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";

@Injectable()
export class CookieInterceptor implements HttpInterceptor {

  /**
   * Sur chaque requete HTTP, et seulement sur les profils non local,
   * on active les credentials (pour pouvoir stocker le cookie XSRF reçu du backend)
   * et on ajoute ce cookie en header si on l'a
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      withCredentials: !environment.local,
      headers: request.headers.set('X-XSRF-TOKEN', this.getCookie("XSRF-TOKEN"))
    });
    return next.handle(request);
  }

  /**
   * Récupération d'un cookie par son nom
   * @param name
   * @private
   */
  private getCookie(name: string): string | string[] {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
      return match[2]
    } else {
      return [];
    }
  }
}
